import "./Logo_MAQ.css"

export function Logo_MAQ ({props}) {

  return (
    <a href="../index.php">
    <svg viewBox="0 0 164 125" className="logo_MAQ">
    <g filter="url(#filter0_d)">
      <path d="M103 4H81.5992L53.5837 37.3456L26.7354 4H3V112H25.5681L26.7354 46.3041L53.5837 79.6498L81.5992 44.8111V77.7246L84.5 80L89.5 82.5L96 84.5L103 84V4Z" fill="#314159" fillOpacity="0.5"/>
      <path d="M103 4H81.5992L53.5837 37.3456L26.7354 4H3V112H25.5681L26.7354 46.3041L53.5837 79.6498L81.5992 44.8111V77.7246L84.5 80L89.5 82.5L96 84.5L103 84V4Z" stroke="black"/>
    </g>
    <g filter="url(#filter1_d)">
      <path d="M81 53.5V117.5H68.5V95.5H56L38.5 117.5H22L81 45V53.5Z" fill="#BADA45" fillOpacity="0.5"/>
      <path d="M81 53.5V117.5H68.5V95.5H56L38.5 117.5H22L81 45V53.5Z" stroke="black"/>
    </g>
    <g filter="url(#filter2_d)">
      <path d="M68.5 86.5H61L68.5 75V86.5Z" fill="#8D4E4E"/>
      <path d="M68.5 86.5H61L68.5 75V86.5Z" stroke="black"/>
    </g>
    <g filter="url(#filter3_d)">
      <path d="M123 63.038C124.5 50.5 120.5 38 103 32.6046V21.5311V11C125.619 12.3706 147.924 32.4289 146.09 63.038C145.65 70.394 143.112 78.1002 138.805 85L155 103.871L139.213 111.5L127.718 97.5523C116.277 106.763 100.123 111.129 81 104.5V77.8554C103 96 121.5 75.5759 123 63.038Z" fill="#A52A2A" fillOpacity="0.5"/>
      <path d="M123 63.038C124.5 50.5 120.5 38 103 32.6046V21.5311V11C125.619 12.3706 147.924 32.4289 146.09 63.038C145.65 70.394 143.112 78.1002 138.805 85L155 103.871L139.213 111.5L127.718 97.5523C116.277 106.763 100.123 111.129 81 104.5V77.8554C103 96 121.5 75.5759 123 63.038Z" stroke="black"/>
    </g>
    <defs>
      <filter id="filter0_d" x="0.5" y="0.5" width="111" height="119" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dx="3" dy="2"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <filter id="filter1_d" x="18.9485" y="40.5934" width="70.5515" height="84.4066" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dx="3" dy="2"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <filter id="filter2_d" x="60.077" y="73.318" width="8.92302" height="13.682" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <filter id="filter3_d" x="78.5" y="7.46878" width="85.3026" height="111.652" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dx="3" dy="2"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
    </defs>
    </svg>
    </a>
  );
}